<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Products Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> / <b>Reports</b> /
      <b>Products</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="nav-icon fas fa-handshake" style="font-size:50px"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Transactions Quantity</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                {{ this.transactions }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="nav-icon fas fa-handshake" style="font-size:50px"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Claims Quantity</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                {{ this.claimQuantity }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i
              class="nav-icon fas fa-money-bill-wave"
              style="font-size:50px"
            ></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Total Amount</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                ${{ this.amount }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-12 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">
              <button class="btn btn-primary" @click="print">Print</button>
            </div>
            <div id="printGraph">
              <GChart
                type="ColumnChart"
                :data="quantityData"
                :options="quantityOptions"
              />

              <GChart
                type="ColumnChart"
                :data="salesData"
                :options="salesOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mb-4">
				<div class="col-lg-12 col-md-12">
					<div class="card mb-4">
						<div class="card-body">
							<div class="card-title"><button class="btn btn-primary" @click="print">Print</button></div>
							<div id="printGraph">
								<GChart
									type="ColumnChart"
									:data="quantityData"
									:options="quantityOptions"
								/>

								<GChart
									type="ColumnChart"
									:data="salesData"
									:options="salesOptions"
								/>
							</div>
						</div>
					</div>
				
				</div>
			</div> -->

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input class="form-control" type="date" v-model="date_from" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input class="form-control" type="date" v-model="date_to" />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label><b>Takaful Scheme</b></label>
                <select class="form-control" v-model="productFilter">
                  <option value="" selected>All</option>
                  <option
                    v-for="(productOption, product_index) in productOption"
                    :key="product_index"
                    :value="productOption.id"
                    >{{ productOption.name }}</option
                  >
                </select>
              </div>
            </div>
            <br />
            <div class="text-right">
              <button
                @click="submitFilter()"
                class="btn btn-rounded btn-primary"
                style="width: 150px;"
              >
                Submit
              </button>
            </div>
            <br />
            <div class="table-responsive">
              <table
                id="product_table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: left;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Takaful Scheme</th>
                    <th>Transaction Quantity</th>
                    <th>Claim Quantity</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(prod, prod_index) in products" :key="prod_index">
                    <td>{{ prod_index + 1 }}</td>
                    <td>{{ prod.name }}</td>
                    <td>{{ prod.transactions }}</td>
                    <td>{{ prod.claims }}</td>
                    <td>{{ prod.amount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";

import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart
  },

  data() {
    return {
      quantityData: [],

      quantityOptions: {
        title: "Musafir Orders by Quantity (Overall)",
        height: 500,
        legend: "bottom"
      },

      salesData: [],

      salesOptions: {
        title: "Musafir Orders by Sales (Overall)",
        height: 500,
        legend: "bottom"
      },

      products: [
        {
          name: "",
          transactions: "",
          claims: "",
          amount: ""
        }
      ],

      transactions: "",
      claimQuantity: "",
      amount: "",

      productOption: "",
      date_from: "",
      date_to: "",
      productFilter: ""
    };
  },

  methods: {
    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    getData() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        // axios.get('/reports/specifics?group_month=1',
        axios
          .post(
            "/reports/products",
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.allData = res.data;
            // this.columnData = this.allData
            var obj = [];
            var obj2 = [];

            // this.quantityData = res.data.quantity
            this.quantityData = res.data.qty_sales;
            this.salesData = res.data.graph_sales;
          });
      }
    },

    loadProducts() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/reports/products",
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.products = res.data.records;
            this.transactions = res.data.total_orders;
            this.claimQuantity = res.data.total_claims;
            this.amount = res.data.total_sales;
          });
      }
    },

    loadProductOption() {
      let token = localStorage.getItem("token");

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/products/staff", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.productOption = res.data;
          });
      }
    },

    submitFilter() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        $("#product_table")
          .DataTable()
          .destroy();
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/reports/products",
            {
              product: this.productFilter,
              date_to_p: this.date_to,
              date_from_p: this.date_from
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.products = res.data.records;
            this.transactions = res.data.total_orders;
            this.claimQuantity = res.data.total_claims;
            this.amount = res.data.total_sales;
            setTimeout(function() {
              $("#product_table").DataTable({
                dom: "Bfrtip",
                lengthMenu: [
                  [5, 10, 25, 50, -1],
                  ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
                ],
                buttons: [
                  "pageLength",
                  "colvis",
                  "csv",
                  "excel",
                  "pdf",
                  "print"
                ]
              });
            }, 2000);
          });
      }
    },

    loadAllData() {
      this.loadProducts();
      this.getData();
      this.loadProductOption();
      setTimeout(function() {
        $("#product_table").DataTable({
          dom: "Bfrtip",
          lengthMenu: [
            [5, 10, 25, 50, -1],
            ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
          ],
          buttons: ["pageLength", "colvis", "csv", "excel", "pdf", "print"]
        });
      }, 2000);
    }
  },

  mounted() {
    //   $("#new_transaction1").DataTable( {
    //     dom: 'Bfrtip',
    //     lengthMenu: [
    //         [ 10, 25, 50, -1 ],
    //         [ '10 rows', '25 rows', '50 rows', 'Show all' ]
    //     ],
    //     buttons: [
    //         'pageLength', 'colvis', 'csv', 'excel', 'pdf', 'print'
    // 	],
    // });
    // let myChart = echarts.init(document.getElementById('myChart'))
    // myChart.setOption(this.option);
    this.loadAllData();
  }
};
</script>
